import { HTMLProps, useState } from 'react';

import Logo from '@svg/shafa-logo.svg';
import { Skeleton } from '@ui/Skeleton';

import { useGetLogoQuery } from './graphql.v5.generated';

type Props = Pick<HTMLProps<HTMLElement>, 'width' | 'height' | 'className'>;

export const ShafaLogo: React.FC<Props> = (props) => {
  const [url, setUrl] = useState('');

  const { loading, data } = useGetLogoQuery({
    context: { v5: true },
    onCompleted(logoData) {
      if (logoData?.logo?.imageWeb) {
        setUrl(logoData?.logo?.imageWeb);
      }
    },
  });

  if (loading) {
    return (
      <Skeleton
        className={props.className}
        width={props.width ? `${props.width}px` : '100%'}
        height={props.height ? `${props.height}px` : '100%'}
      />
    );
  }

  if (url) {
    return (
      <img
        src={url}
        alt={data?.logo?.title}
        title={data?.logo?.title}
        onError={() => setUrl('')}
        {...props}
      />
    );
  }

  return <Logo {...props} />;
};
